import { LICENSE_ACTION_TYPES } from "../../global/constants/licensesConstants";

export const fetchBillingAccountsLicenses = () => ({
  type: "FETCH_BILLING_ACCOUNTS_LICENSES"
});

export const fetchLicenses = (accountId) => ({
  type: "FETCH_LICENSES_OF_ACCOUNT",
  payload: accountId
});

export const fetchLicensesByAccountId = (accountId) => ({
  type: "FETCH_LICENSES_OF_ACCOUNT_BY_ID",
  payload: accountId
});

export const assignLicense = (payload) => ({
  type: LICENSE_ACTION_TYPES.ASSIGN_LICENSE,
  payload
});

export const assignLicenseSuccess = (payload) => ({
  type: LICENSE_ACTION_TYPES.ASSIGN_LICENSE_SUCCESS,
  payload
});

export const assignLicenseFailure = (payload) => ({
  type: LICENSE_ACTION_TYPES.ASSIGN_LICENSE_FAILURE,
  payload
});

/**
 * Dispatch this to run multiple HS license operations in parallel via the saga.
 * The saga handles: API calls + fovList patch + licenseReducer refresh.
 *
 * @param {object} payload
 * @param {Array<{fovId: string, action: "assign"|"resume"|"remove"|"switch", currentSku?: string}>} payload.actions
 * @param {string} payload.accountId
 * @param {Function} payload.resolve  — called when all actions have settled (success or fail)
 */
export const batchLicenseActions = (payload) => ({
  type: LICENSE_ACTION_TYPES.BATCH_LICENSE_ACTIONS,
  payload
});
